import { getStage } from "src/context";
import { Css } from "~generated/css";

export function LocalProdEnvironmentWarning() {
  const stage = getStage();

  if (stage !== "local-prod") {
    console.error(
      "The LocalProdEnvironmentWarning component was instantiated outside the local-prod environment. This should not happen! Please debug where this component is rendered.",
    );
    return null;
  }

  return (
    <div
      // Don't block the menu being accessible if we're on mobile
      css={Css.bgRed100.w100.absolute.z(999).ha.top0.ifMobile.o50.pointerNone.$}
      data-testid="localProdEnvironmentWarning"
    >
      <div css={Css.mx3.$}>
        You are running the app from your local machine against production. Please exercise caution and do not make
        unintended changes to production data.
      </div>
    </div>
  );
}
